import './DuvalPentagonVisualization.scss';

export { schema, getSchema, uiSchema } from '../../schemas/DuvalPentagonVisualizationSchema';

export { default } from './DuvalPentagonVisualization';
